import CultureFlag from "components/Culture/CultureFlag";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import moment from "moment";
import React from "react";
import { useLoaderData } from "react-router";
import { getMainAreaMapping, mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";

const WordTemplateForListListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.WordTemplateForListViewListFrontModel>();

  const mainAreaMapping = getMainAreaMapping(viewModel.mainAreaId);

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet={mainAreaMapping.filterSet}
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={{ ...viewModel.initialInstruction, mainArea: viewModel.mainAreaId }}
        fetchFunction={window.CoreApi.WordTemplateForListView.Paginated}
        getId={item => item.wordTemplateForListViewId}
        onNew={() => window.location.href = mainAreaMapping.new()}
        layout={{
          type: "table",
          columns: [{
            key: "flag",
            header: "",
            size: "52px",
            render: item => <CultureFlag lcid={item.lcid} />
          },
          {
            key: "title",
            header: RESX.GeneralLabels.Title,
            render: item => <div>
              <a href={mainAreaMapping.detail(item.wordTemplateForListViewId)}>{item.title}</a>
            </div>,
            size: "2fr",
          },
          {
            key: "lastModified",
            header: RESX.GeneralLabels.LastModified,
            render: item => moment.utc(item.lastModifiedUtc).fromNow(),
            size: "1fr",
          }]
        }}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction: (filterSet, filter, page, perPage) => mapFilterValuesToInstruction(viewModel.mainAreaId, filterSet, filter, page, perPage)
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
};

export default WordTemplateForListListApp;